<template>
  <div class="news-pagination">
    <nav class="news-pagination-nav">
      <kf-link
        class="news-pagination-btn is-prev"
        :class="{ 'is-hidden': !hasPrev }"
        :href="`${currentPagePath}?page=${currentPage - 1}`"
        :aria-label="i18n.news.btnPrev.label"
      >
        <chevron-left
          class="icon"
        />
      </kf-link>
      <ul class="news-pagination-list">
        <li
          v-if="hasFirst"
          class="news-pagination-list-item is-first"
        >
          <a
            :href="`${currentPagePath}?page=1`"
            class="news-pagination-list-link"
          >
            <span>1</span>

            <shield-small
              v-if="currentPage === 1"
              class="icon"
            />
          </a>
        </li>
        <li
          v-if="hasFirst"
          class="news-pagination-list-item is-dots"
        >
          ...
        </li>
        <li
          v-for="(page, i) in pages"
          :key="i"
          class="news-pagination-list-item"
          :class="{ 'is-active': currentPage === page }"
        >
          <a
            v-if="currentPage !== page"
            :href="`${currentPagePath}?page=${page}`"
            class="news-pagination-list-link"
          >
            <span>{{ page }}</span>

            <shield-small
              v-if="currentPage === page"
              class="icon"
            />
          </a>
          <span
            v-else
            class="news-pagination-list-link"
          >
            <span>{{ page }}</span>
            <shield-small
              v-if="currentPage === page"
              class="icon"
            />
          </span>
        </li>
        <li
          v-if="hasLast"
          class="news-pagination-list-item is-dots"
        >
          ...
        </li>
        <li
          v-if="hasLast"
          class="news-pagination-list-item is-last"
        >
          <a
            :href="`${currentPagePath}?page=${totalPages}`"
            class="news-pagination-list-link"
          >
            <span>{{ totalPages }}</span>

            <shield-small
              v-if="currentPage === totalPages"
              class="icon"
            />
          </a>
        </li>
      </ul>
      <kf-link
        class="news-pagination-btn is-next"
        :class="{ 'is-hidden': !hasNext }"
        :href="`${currentPagePath}?page=${currentPage + 1}`"
        :aria-label="i18n.news.btnNext.label"
      >
        <chevron-right
          class="icon"
        />
      </kf-link>
    </nav>
  </div>
</template>

<script>
import KfLink from '@/components/base/link/Link.vue';

export default {
  name: 'KfNewsPagination',
  components: {
    KfLink,
    ChevronLeft: () => import(/* webpackChunkName: "main"*/ '@/components/svg/ChevronLeft.vue'),
    ChevronRight: () => import(/* webpackChunkName: "main"*/ '@/components/svg/ChevronRight.vue'),
    ShieldSmall: () => import(/* webpackChunkName: "main"*/ '@/components/svg/ShieldSmall.vue'),
  },
  props: {
    i18n: {
      type: Object,
      default: () => {},
    },
    totalPages: {
      type: Number,
      default: 0,
    },
    currentPage: {
      type: Number,
      default: 0,
      required: true,
    },
    pageRange: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    currentPagePath() {
      return window.location.href.split('?')[0].split(window.location.host)[1];
    },
    pages() {
      var pages = [];
      for (let i = this.rangeStart; i <= this.rangeEnd; i++) {
        pages.push(i);
      }
      return pages;
    },
    rangeStart() {
      let start = this.currentPage - this.pageRange;
      return (start > 0) ? start : 1;
    },
    rangeEnd () {
      let end = this.currentPage + this.pageRange;
      return (end < this.totalPages) ? end : this.totalPages;
    },
    hasPrev() {
      return this.currentPage > 1;
    },
    hasNext() {
      return this.currentPage < this.totalPages;
    },
    hasFirst() {
      return this.rangeStart !== 1;
    },
    hasLast() {
      return this.rangeEnd < this.totalPages;
    },
  },
};
</script>

<style lang="postcss">
.news-pagination {
  @apply border-t border-gray-50 pt-4 mt-12;

  &-nav {
    @apply flex justify-between;
  }

  &-btn {
    @apply flex items-center justify-center w-8 h-8;

    .icon {
      width: 16px;
      height: 16px;
    }

    &.is-hidden {
      @apply invisible;
    }
  }

  &-list {
    @apply flex justify-center flex-grow gap-4;

    &-item {
      @apply hidden relative items-center justify-center w-8 h-8;

      @screen md {
        @apply flex;
      }

      &.is-active {
        @apply flex;

        .news-pagination-list-link {
          @apply text-white;
        }
      }

      &.is-first,
      &.is-last,
      &.is-dots {
         @apply flex;
      }

    }

    &-link {
      @apply flex items-center justify-center text-base no-underline w-full h-full;

      > span {
        @apply relative;
        z-index: 2;
      }

      .icon {
        @apply absolute top-0 left-0 text-primary-bravo;

        z-index: 1;
      }
    }
  }

}
</style>

